import { takeLatest, call, put } from 'redux-saga/effects';
import ContactAPI from '../../utils/api/contact';
import { setSubmitted } from './actions';
import { ENQUIRE } from './constants';

function* enquireFlow({ payload: { values, form } }) {
  try {
    const response = yield call(ContactAPI.enquire, values);
    // TODO...
    yield put(setSubmitted(true));
  } catch (e) {
    form.setErrors({ general: e.message });
  }
  form.setSubmitting(false);
}

export function* componentFlow() {
  yield takeLatest(ENQUIRE, enquireFlow);
}

export default componentFlow;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/sagas.js